export const product_events = {
  documentTitle: "Product events",
  title: "Product events",
  filter_label: "Filter by event name",
  refresh: "Refresh",
  empty: "No product events recorded yet.",
  columns: {
    id: "ID",
    name: "Name",
    source: "Source",
    timestamp: "Timestamp",
    payload: "Payload",
  },
};
